import { render, staticRenderFns } from "./AsideContentLayout.vue?vue&type=template&id=89ae0aca&scoped=true&"
import script from "./AsideContentLayout.vue?vue&type=script&lang=js&"
export * from "./AsideContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./AsideContentLayout.vue?vue&type=style&index=0&id=89ae0aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ae0aca",
  null
  
)

export default component.exports